/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const staffSchema = z.object({
	id: z.uuid(),
	name: z.string().nullable(),
	tg_id: z.bigint().nullish().describe("Уникальный идентификатор пользователя в Telegram"),
	tg_username: z.string().max(63).nullish().describe("Username пользователя в Telegram"),
	external_id: z.uuid(),
	organization: z.uuid(),
	org_unit: z.uuid().nullish(),
	ntech_id: z.int().nullable(),
	ntech_picture: z.url().nullable(),
});
